<template>
  <div class="text-block block-card card-border big-card-block">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <img 
                src="../../../../assets/img/airplane.png" 
                alt="">
            </div>

            <h4>
              Flight 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount">
          <div class="block-card-body" v-if="validData">
            <label >Intro Message</label>
            <vTextareaAutocomplete 
              v-model="data.intro_message" 
              :type="'textfield'"
              :validation-rules=" [v => !!v || 'Message is Required']"/>

          <label >Status</label>

          <vTextareaAutocomplete v-model="data.status" :type="'textfield'"
                                 :validationRules=" [v => !!v || 'Status is Required']">
          </vTextareaAutocomplete>

          <label >Status Color</label>
          <vTextareaAutocomplete v-model="data.status_color" :type="'textfield'"
                                 :validationRules=" [v => !!v || 'Status color is Required']">
          </vTextareaAutocomplete>




            <label >Date</label>
            <!--                    <v-text-field-->
            <!--                            outline-->
            <!--                            v-model="data.date"-->
            <!--                            :error="!data.date"-->
            <!--                            :error-messages="!data.date? 'Date is Required':''"-->
            <!--                    >-->
            <!--                    </v-text-field>-->
            <vTextareaAutocomplete 
              v-model="data.date" 
              :type="'textfield'"
              :validation-rules=" [v => !!v || 'Date is Required']"/>
            <v-layout>
              <v-flex 
                sm4 
                class="pa-0">
                <label >Flight</label>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.flight"-->
                <!--                                    :error="!data.flight"-->
                <!--                                    :error-messages="!data.flight? 'flight is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.flight" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'flight is Required']"/>
              </v-flex>
              <v-flex sm4>
                <label >Departs</label>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.departs"-->
                <!--                                    :error="!data.departs"-->
                <!--                                    :error-messages="!data.departs? 'Departs is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.departs" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Departs is Required']"/>
              </v-flex>
              <v-flex 
                sm4 
                class="pa-0">
                <label >Arrives</label>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.arrives"-->
                <!--                                    :error="!data.arrives"-->
                <!--                                    :error-messages="!data.arrives? 'Arrives is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete
                  v-model="data.arrives"
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Arrives is Required']"
                  hint="Example 2015-12-26T11:30"
                />
              </v-flex>
            </v-layout>
            <v-layout class="mt-4 align-center">
              <v-flex 
                sm4 
                class="pa-0">
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.travel.originName"-->
                <!--                                    :error="!data.travel.originName"-->
                <!--                                    placeholder="Origin Name"-->

                <!--                                    :error-messages="!data.travel.originName? 'Origin Name is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.travel.originName" 
                  :type="'textfield'" 
                  :validation-rules=" [v => !!v || 'Origin Name is Required']"
                  hint="Example 2015-12-26T11:30"/>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.travel.originAcronym"-->
                <!--                                    :error="!data.travel.originAcronym"-->
                <!--                                    placeholder="Origin Acc"-->
                <!--                                    :error-messages="!data.travel.originAcronym? 'Origin is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.travel.originAcronym" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Acronym name is Required']"/>

              </v-flex>

              <v-flex 
                sm4 
                class="text-sm-center">
                <v-icon 
                  color="primary" 
                  large>airplanemode_active</v-icon>
              </v-flex>

              <v-flex 
                sm4 
                class="pa-0">
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.travel.destName"-->
                <!--                                    :error="!data.travel.destName"-->
                <!--                                    placeholder="Destination"-->
                <!--                                    :error-messages="!data.travel.destName? 'Destination Name is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.travel.destName" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Destination name is Required']"/>
                <!--                            <v-text-field-->
                <!--                                    outline-->
                <!--                                    v-model="data.travel.destAcronym"-->
                <!--                                    :error="!data.travel.destAcronym"-->
                <!--                                    placeholder="destAcronym"-->
                <!--                                    :error-messages="!data.travel.destAcronym? 'destAcronym Name is Required':''"-->
                <!--                            >-->
                <!--                            </v-text-field>-->
                <vTextareaAutocomplete 
                  v-model="data.travel.destAcronym" 
                  :type="'textfield'"
                  :validation-rules=" [v => !!v || 'Destination Acronym name is Required']"/>

              </v-flex>

            </v-layout>
          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
export default {
  name: 'CardFlight',
  components: {
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>
